
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M291.2 454.4l-128-220.8C243.2 131.2 371.2 64 512 64c163.2 0 307.2 89.6 384 220.8H512c-105.6-3.2-195.2 70.4-220.8 169.6zM672 348.8h256c19.2 51.2 32 105.6 32 163.2 0 246.4-198.4 444.8-441.6 448l182.4-316.8c25.6-38.4 41.6-83.2 41.6-131.2 0-64-28.8-121.6-70.4-163.2zM348.8 512c0-89.6 73.6-163.2 163.2-163.2S675.2 422.4 675.2 512 601.6 675.2 512 675.2 348.8 601.6 348.8 512zm224 220.8l-128 220.8C230.4 921.6 64 736 64 512c0-80 22.4-153.6 57.6-220.8L304 608c35.2 76.8 115.2 131.2 208 131.2 22.4 3.2 41.6 0 60.8-6.4z","fill":"#040000"}})])
          )
        }
      }
    